import { combineReducers } from 'redux';
import menu from './menu/reducer';
import auth from './auth/reducer';

const reducers = combineReducers({
  menu,
  auth
});

export default reducers;